import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axiosInstance from "../../utils/axiosInstance";

export const fetchChallengesAndPartners = createAsyncThunk(
  "journey/fetchChallengesAndPartners",
  async (id) => {
    const response = await axiosInstance(
      `/challenges/${id}?include=partner`,
      "get",
    );
    return response.data.data;
  },
);

export const fetchCurrentQuest = createAsyncThunk(
  "journey/fetchCurrentQuest",
  async (id) => {
    const response = await axiosInstance(`/quests?capsule_id=${id}`, "get");
    return response.data.data;
  },
);

const journeySlice = createSlice({
  name: "journey",
  initialState: {
    challenges: {},
  },
  extraReducers: (builder) => {
    builder.addCase(fetchChallengesAndPartners.fulfilled, (state, action) => {
      state.challenges = action.payload;
    });
  },
});

export default journeySlice.reducer;
